
import FileInputDropDown from /* webpackChunkName: "FileInputDropDown" */ '~/components/file-io/FileInputDropDown'

export default {
  name: 'DropZone',
  components: {
    FileInputDropDown
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    single: {
      default: false,
      required: false
    },
    // eslint-disable-next-line vue/require-prop-types
    preview: {
      default: false,
      required: false
    }
  },
  data: () => ({
    dragging: false,
    inputLoaded: false
  }),
  computed: {
    loggedIn () {
      return this.$auth ? this.$auth.Token : false
    },
    info () {
      return this.$store.state.info
    },
    UploadMaxLimit () {
      return this.$store.state.subscription.plan.maxFileSizeInGb
    },
    hasFiles () { return !!this.$store.state.list.length },
    isMaxSupportedFileSize () {
      return !!(this.$store.state.subscription.plan.isMaxSupportedFile)
    }
  },
  mounted () {
  },
  methods: {
    addFiles (e) {
      this.$refs.FileInputDropDown.addFiles(e)
    }
  }
}
